<div class="col-sm-12">
  @for (ticket of tickets; track ticket) {
    @if (!filter || ((filter===this.ticketKind.Asset && ticket.isAssetTicket) || (filter===this.ticketKind.Gateway && ticket.isGatewayTicket) || (filter===this.ticketKind.Site && ticket.isSiteTicket))) {
      <div  [@fadeInOut]>
        <app-issue-ticket  [ticket]="ticket"></app-issue-ticket>
      </div>
    }
  }
</div>